<zimmerer-route-ion-wrapper class="ion-page">

  <div class="wrapper padding-content">
    <p>
      Ihr Konto wird verifiziert, bitte warten.
    </p>
  </div>

  <app-footer></app-footer>

</zimmerer-route-ion-wrapper>